import { useEffect, useState } from "react";
import { DeploymentPage } from "./deployment/DeploymentPage";
import { Box, Button, CssBaseline, Typography } from "@mui/material";
import PageHeader from "../components/PageHeader";
import { callRobotApi, WifiConfig } from "./hmi/robot-api";
import { OpenInBrowser, RestartAlt, WifiLock } from "@mui/icons-material";
import { PropValueLine } from "../panels/common/PropValueLine";
import { WiFiConfig } from "./hmi/WiFiConfig";

export enum EditorMode {
  HMI = "hmi",
  Landing = "landing",
  Wifi = "wifi",
}

export function RobotLandingPage() {
  const [editorMode, setEditorMode] = useState(EditorMode.Landing);
  const [wifiConfig, setWifiConfig] = useState<WifiConfig | null>(null);
  useEffect(() => {
    (async () => {
      const wifiConfig = await callRobotApi('wifi');
      setWifiConfig(wifiConfig);
    })();
  }, []);
  if (editorMode === EditorMode.HMI) {
    return (
      <DeploymentPage />
    );
  } else if (editorMode === EditorMode.Wifi && wifiConfig) {
    return (
      <WiFiConfig setEditMode={setEditorMode} wifiConfig={wifiConfig} setWifiConfig={setWifiConfig} />
    );
  } else {
    return (
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            m: 0,
            backgroundColor: "#212121",
            color: "#ECECEC",
            minHeight: "100vh",
          }}
        >
          <PageHeader
            title={"Techmage HMI"}
            rightComponent={[]}
          />
          <Box sx={{ p: 4, display: 'flex', flexDirection: 'row', gap: 4 }}>
            <Button variant="contained" color="secondary" size='large' onClick={() => setEditorMode(EditorMode.HMI)}>
              <div>
                <OpenInBrowser fontSize="large" />
                <Typography variant="h4">
                  Open HMI
                </Typography>
              </div>
            </Button>
            <Button variant="contained" color="success" size='large' onClick={() => setEditorMode(EditorMode.Wifi)}>
              <div>
                <Typography variant="h4">
                  WIFI
                </Typography>
                <div>
                  {wifiConfig ? <>
                    <PropValueLine label='SSID' value={wifiConfig.ssid} />
                    <PropValueLine label='IP' value={wifiConfig.ip} />
                    <PropValueLine label='Adapter' value={wifiConfig.adapter} />
                  </>
                    : "No Network Connection"}
                </div>
              </div>
            </Button>

            <Button variant="contained" color="error" size='large' onClick={async () => {
              await callRobotApi('dropwifi');
              const wifiConfig = await callRobotApi('wifi');
              setWifiConfig(wifiConfig);
            }}>
              <div>
                <WifiLock fontSize="large" />
                <Typography variant="h4">
                  DROP WIFI
                </Typography>
              </div>
            </Button>


            <Button variant="contained" color="error" size='large' onClick={async () => {
              await callRobotApi('restart');
            }}>
              <div>
                <RestartAlt fontSize="large" />
                <Typography variant="h4">
                  RESTART
                </Typography>
              </div>
            </Button>


          </Box>
        </Box>
      </Box>

      // <div style={{ color: 'white', textAlign: 'center', marginTop: '20%' }}>
      //   <h1>TechMage Robot HMI</h1>
      //   <Button variant="contained" color="secondary" size='large' onClick={() => setOpenHmi(true)}>
      //     Open
      //   </Button>
      // </div>
    );
  }
}